import { ChangeDetectionStrategy,Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatFormField, MatLabel, MatPrefix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { KeysResults } from 'fuzzysort';

import { AdminComponentBase, PageSimpleContentComponent } from 'app/layout/content';
import { ErrorComponent } from 'app/shared/components/error.component';
import { PromptDialogService } from 'app/shared/dialog/prompt-dialog.service';
import { FuzzySortResultHighlightComponent } from 'app/shared/fuzzysort-helper/fuzzy-sort-result-highlight.component';
import { emptyFuzzySortOnKeys, executeFuzzySortOnKeys, KeysOfUnion } from 'app/shared/fuzzysort-helper/fuzzysort-helper';
import { Library } from 'app/shared/graph';

import { LibraryUpdateService } from './library-update.service';

@Component({
    selector: 'admin-libraries-page',
    templateUrl: './libraries-page.component.html',
    styleUrls: ['./libraries-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [PageSimpleContentComponent, MatFormField, MatIcon, MatPrefix, MatLabel, MatInput, FormsModule, MatButton, ErrorComponent, MatDivider, RouterLink, FuzzySortResultHighlightComponent]
})
export class LibrariesPageComponent extends AdminComponentBase implements OnInit, OnDestroy {
    private readonly promptService = inject(PromptDialogService);
    private readonly libraryUpdateService = inject(LibraryUpdateService);
    private readonly route = inject(ActivatedRoute);
    private readonly router = inject(Router);

    libraries: Library[] = [];
    filter = '';
    fuzzySearchKeys: Array<KeysOfUnion<Library>> = ['owner'];
    displayedLibraries: KeysResults<Library> = emptyFuzzySortOnKeys();

    ngOnInit(): void {
        this.subscribeWithGenericLoadingErrorHandling(this.libraryUpdateService.getLibraries(), (libraries) => {
            this.libraries = libraries;
            this.updateDisplayedLibraries();
        });
    }

    ngOnDestroy(): void {
        this.unsubscribeSubscriptions();
    }

    deployNewLibrary() {
        this.promptService.prompt('Deploy a new library', 'The name of the library (should match the name of the Git repository)', {
            fieldLabel: 'Owner'
        }).subscribe(result => {
            this.router.navigate([result], { relativeTo: this.route });
        });
    }

    updateDisplayedLibraries() {
        this.displayedLibraries = executeFuzzySortOnKeys(this.filter ?? '', this.libraries, this.fuzzySearchKeys);
    }
}
